import React from 'react';
import { useLocation } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { ReplaceLink } from 'js/components';
import { teamIdFromOrgDetailSearch } from 'js/utils/org-detail-url';
import {
  buildSnapshotTrendsPickerPath,
  isSnapshotTrendsPath,
  snapshotSetPath,
  snapshotTrendsPath,
} from './org-snapshot-utils';

export default function OrgSnapshotSetTabs({
  workspaceId,
  orgId,
  sourceType,
  sourceKey,
  pathname = '',
  subOrgId,
}) {
  const location = useLocation();

  if (!sourceKey) {
    return null;
  }

  const listTo = snapshotSetPath(workspaceId, orgId, sourceType, sourceKey);
  const trendsBase = snapshotTrendsPath(
    workspaceId,
    orgId,
    sourceType,
    sourceKey
  );
  const onTrends = isSnapshotTrendsPath(pathname);
  const trendsTo = onTrends
    ? buildSnapshotTrendsPickerPath({
        workspaceId,
        orgId,
        sourceType,
        sourceKey,
        subOrgId,
        teamId: teamIdFromOrgDetailSearch(location.search),
      })
    : { pathname: trendsBase };
  const trendsActive =
    pathname === trendsBase || pathname.startsWith(`${trendsBase}/`);

  return (
    <Nav className="tab-nav nav-underline">
      <NavItem>
        <NavLink
          tag={ReplaceLink}
          data-view="snapshot-list"
          active={!trendsActive}
          to={{ pathname: listTo, state: { noScroll: true } }}
        >
          Snapshots
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={ReplaceLink}
          data-view="snapshot-trends"
          active={trendsActive}
          to={{ ...trendsTo, state: { noScroll: true } }}
        >
          Trends
        </NavLink>
      </NavItem>
    </Nav>
  );
}
